import { paymentPeriods } from './constants';

/**
 * Returns formatted amount.
 * For example: 1240 formatted to 1 240.
 * @param {any} amount Amount in rubles.
 * @returns {string} Formatted amount.
 */
export default function formatAmount(amount) {
    return amount.toString().replace(/[^0-9.]/gi, '').replace(/(\d)(?=(\d{3})+(\.\d{2,}){0,1}$)/gi, '$1 ');
}

/**
 * Format date to human format.
 * @param {string} date Date in any format.
 * @returns {string} Formatted date.
 */
function formatDate(date) {
    date = new Date(date);

    function formatMonth() {
        const months = ['Янв', 'Фев', 'Мар', 'Апр', 'Мая', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'];

        return months[date.getMonth()];
    }

    function getYear(date) {
        const today = new Date();

        return today.getFullYear() === date.getFullYear() ? '' : date.getFullYear();
    }

    return `${date.getDate()} ${formatMonth()} ${getYear(date)}`;
}

/**
 * Get time from specified date.
 * @param {string} date Date string.
 * @returns Time formatted like 12:32
 */
function getTimeFromDate(date) {
    date = new Date(date);

    function addPrefixZero(num) {
        return num < 10 ? '0' + num : num;
    }

    const hours = addPrefixZero(date.getHours());
    const minutes = addPrefixZero(date.getMinutes());

    return `${hours}:${minutes}`;
}

function getPaymentPeriod(once_per_days) {
    if (once_per_days !== undefined) {
        return paymentPeriods[once_per_days] || 'период';
    }

    return 'период';
}

export { formatDate, getTimeFromDate, getPaymentPeriod };
